// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  --background: #ffffff;
}

ion-header {
  box-shadow: none;
  border-bottom: 1px solid var(--color-black);
}

h1, h2, h3, h4, h5 {
  font-size: 20px;
  line-height: 116%;
  letter-spacing: 0.02em;
  vertical-align: middle;
  text-transform: uppercase;
  margin-top: 20px;
  margin-bottom: 10px;
  font-family: AppFontBold;
  text-align: center;
  color: var(--color-black);
  font-weight: 700;
}
@media (max-width: 992px) {
  h1, h2, h3, h4, h5 {
    font-size: 16px;
  }
}

.legal__content {
  max-width: 800px;
  margin: 0 auto;
}

h4 {
  font-size: 18px;
}
@media (max-width: 992px) {
  h4 {
    font-size: 15px;
  }
}

p {
  font-size: 16px;
  line-height: 120%;
  vertical-align: middle;
  text-align: center;
  text-transform: uppercase;
  margin-bottom: 10px;
  color: var(--color-black);
}
@media (max-width: 992px) {
  p {
    font-size: 14px;
  }
}
p:has(strong) {
  margin-top: 25px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/privacy/privacy.page.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACE,qBAAA;AADF;;AAGA;EACE,gBAAA;EACA,2CAAA;AAAF;;AAEA;EACC,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,sBAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;EACC,wBAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;AACF;ACdE;EDEF;IAaI,eAAA;EAGF;AACF;;AAAA;EACE,gBAAA;EACA,cAAA;AAGF;;AAAA;EACE,eAAA;AAGF;AC5BE;EDwBF;IAGI,eAAA;EAKF;AACF;;AAFA;EACC,eAAA;EACA,iBAAA;EACA,sBAAA;EACC,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,yBAAA;AAKF;AC3CE;ED+BF;IAUI,eAAA;EAMF;AACF;AAJE;EACE,gBAAA;AAMJ","sourcesContent":["@import '../../../theme/mixins';\n\nion-content {\n  --background: #ffffff;\n}\nion-header {\n  box-shadow: none;\n  border-bottom: 1px solid var(--color-black);\n}\nh1,h2, h3, h4, h5 {\n\tfont-size: 20px;\n\tline-height: 116%;\n\tletter-spacing: 0.02em;\n\tvertical-align: middle;\n\ttext-transform: uppercase;\n\tmargin-top: 20px;\n\tmargin-bottom: 10px;\n  font-family: AppFontBold;\n  text-align: center;\n  color: var(--color-black);\n  font-weight: 700;\n  @include mobile {\n    font-size: 16px;\n  }\n}\n\n.legal__content {\n  max-width: 800px;\n  margin: 0 auto;\n}\n\nh4 {\n  font-size: 18px;\n  @include mobile {\n    font-size: 15px;\n  }\n}\n\np {\n\tfont-size: 16px;\n\tline-height: 120%;\n\tvertical-align: middle;\n  text-align: center;\n  text-transform: uppercase;\n  margin-bottom: 10px;\n  color: var(--color-black);\n\n  @include mobile {\n    font-size: 14px;\n  }\n\n  &:has(strong) {\n    margin-top: 25px;\n  }\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
